/**
 * Handlekurv-regler (v2, generalisert): Mønster fra utvalgte merker krever
 * minst N nøster Garn fra SAMME merke i kurven før kassen åpnes.
 *
 * Håndhevelsen er klientside (tema) — «Kjøp nå»-knappen er fjernet for de
 * samme mønstrene i buy-buttons.liquid, så kurven er eneste vei til kassen.
 * Kurvdata leses fra /cart.js (product_type/vendor per linje); strikke-
 * pakke-komponenter ligger som egne linjer med ekte merke og teller derfor
 * mot garn-kravet.
 */
(function () {
  "use strict";

  /**
   * Én regel per merke: Mønster fra `vendor` krever minst `minAntall`
   * nøster Garn fra merkene i `garnFra` (utelatt = samme merke).
   * `vendor`/`garnFra` matcher butikkens EKSAKTE vendor-strenger;
   * `visnavn`/`garnVisnavn` er kundeteksten. Designermerkene (Lindtein-
   * strikk, Linka Neumann) har ikke eget garn — garnkravet peker på
   * merkene kundene faktisk strikker dem i (fra ordrehistorikken).
   */
  var REGLER = {
    utloserType: "Mønster",
    kravType: "Garn",
    // Strikkepakker ligger som ÉN linje i kurven (komponentene pakkes
    // først ut i kassen) — en pakke fra godkjent merke inneholder alltid
    // nok garn og oppfyller kravet alene.
    pakkeType: "Strikkepakke",
    minAntall: 2,
    merker: [
      { vendor: "Permin", visnavn: "Permin" },
      { vendor: "Hillesvåg Ullvarefabrikk", visnavn: "Hillesvåg" },
      { vendor: "Navia", visnavn: "Navia" },
      { vendor: "Rowan", visnavn: "Rowan" },
      { vendor: "Rauma Garn", visnavn: "Rauma" },
      // garnFra "alle": hvilket som helst garn teller
      { vendor: "Lindteinstrikk", visnavn: "Lindteinstrikk", garnFra: "alle" },
      { vendor: "Linka Neumann", visnavn: "Linka Neumann", garnFra: "alle" },
      { vendor: "Ístex", visnavn: "Ístex", garnFra: "alle" },
    ],
  };

  var NOTICE_CLASS = "cart-rules-notice";
  var DISABLED_ATTR = "data-cart-rules-disabled";

  var sisteBrudd = [];

  function evaluerKurv(cart) {
    var brudd = [];
    REGLER.merker.forEach(function (regel) {
      var harMonster = cart.items.some(function (i) {
        return i.product_type === REGLER.utloserType && i.vendor === regel.vendor;
      });
      if (!harMonster) return;
      var alleMerker = regel.garnFra === "alle";
      var godkjenteMerker = alleMerker ? null : regel.garnFra || [regel.vendor];
      var godkjent = function (i) {
        return alleMerker || godkjenteMerker.indexOf(i.vendor) !== -1;
      };
      var garn = cart.items.reduce(function (sum, i) {
        return i.product_type === REGLER.kravType && godkjent(i)
          ? sum + i.quantity
          : sum;
      }, 0);
      var harPakke = cart.items.some(function (i) {
        return i.product_type === REGLER.pakkeType && godkjent(i);
      });
      if (harPakke) return; // strikkepakke fra godkjent merke = nok garn
      if (garn < REGLER.minAntall)
        brudd.push({
          visnavn: regel.visnavn,
          garnVisnavn: alleMerker ? null : regel.garnVisnavn || regel.visnavn,
          har: garn,
          trenger: REGLER.minAntall,
        });
    });
    return brudd;
  }

  function melding(b) {
    var tekst = b.garnVisnavn
      ? "Oppskrifter fra " + b.visnavn + " strikkes i garn fra " + b.garnVisnavn +
        ". Legg til minst " + b.trenger + " nøster for å fullføre kjøpet"
      : "Oppskrifter fra " + b.visnavn + " selges sammen med garn. Legg til " +
        "minst " + b.trenger + " nøster garn (valgfritt merke) for å fullføre kjøpet";
    if (b.har > 0) tekst += " — du har " + b.har + " av " + b.trenger;
    return tekst + ".";
  }

  function lagNotice(brudd) {
    var boks = document.createElement("div");
    boks.className = NOTICE_CLASS;
    boks.setAttribute("role", "alert");
    boks.style.cssText =
      "margin:0 0 1rem;padding:1rem 1.2rem;border:1px solid #c9a227;" +
      "border-radius:8px;background:#fdf6e3;color:#5c4a00;font-size:1.3rem;line-height:1.5;";
    brudd.forEach(function (b) {
      var p = document.createElement("p");
      p.style.margin = "0";
      p.textContent = melding(b);
      boks.appendChild(p);
    });
    return boks;
  }

  function oppdaterUI() {
    var brudd = sisteBrudd;
    var knapper = document.querySelectorAll(
      '#CartDrawer-Checkout, #checkout, button[name="checkout"]'
    );
    knapper.forEach(function (knapp) {
      var beholder = knapp.closest(".cart__ctas") || knapp.parentElement;
      var eksisterende = beholder
        ? beholder.parentElement.querySelector("." + NOTICE_CLASS)
        : null;
      if (brudd.length > 0) {
        knapp.disabled = true;
        knapp.setAttribute(DISABLED_ATTR, "1");
        knapp.setAttribute("aria-disabled", "true");
        if (eksisterende) eksisterende.replaceWith(lagNotice(brudd));
        else if (beholder)
          beholder.parentElement.insertBefore(lagNotice(brudd), beholder);
      } else {
        if (knapp.getAttribute(DISABLED_ATTR)) {
          knapp.disabled = false;
          knapp.removeAttribute(DISABLED_ATTR);
          knapp.removeAttribute("aria-disabled");
        }
        if (eksisterende) eksisterende.remove();
      }
    });
    // Ekspressknapper på cart-siden (Shop Pay m.fl.) følger samme sperre
    document
      .querySelectorAll(".cart__dynamic-checkout-buttons")
      .forEach(function (el) {
        el.style.display = brudd.length > 0 ? "none" : "";
      });
  }

  var evaluerer = false;
  function evaluer() {
    if (evaluerer) return;
    evaluerer = true;
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        sisteBrudd = evaluerKurv(cart);
        oppdaterUI();
      })
      .catch(function () { /* nettverksfeil: ikke sperr */ })
      .finally(function () { evaluerer = false; });
  }

  // Kurvendringer skjer via fetch mot /cart/*-endepunktene — evaluer på nytt
  // etter hver av dem (add/change/update/clear).
  var opprinneligFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === "string" ? arguments[0] : (arguments[0] && arguments[0].url) || "";
    var resultat = opprinneligFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      resultat.finally(function () { setTimeout(evaluer, 150); });
    }
    return resultat;
  };

  // Dawn bytter ut cart-drawerens innhold ved oppdatering — legg sperren
  // tilbake når checkout-knappen gjenskapes.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (
          node.nodeType === 1 &&
          (node.querySelector
            ? node.querySelector('button[name="checkout"]')
            : false)
        ) {
          oppdaterUI();
          return;
        }
      }
    }
  });

  // Siste skanse: blokker klikk selv om UI-tilstanden skulle henge etter
  document.addEventListener(
    "click",
    function (e) {
      var knapp = e.target && e.target.closest && e.target.closest('button[name="checkout"]');
      if (knapp && sisteBrudd.length > 0) {
        e.preventDefault();
        e.stopPropagation();
        oppdaterUI();
        var notice = document.querySelector("." + NOTICE_CLASS);
        if (notice) notice.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
    true
  );

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    evaluer();
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", start);
  else start();
})();
